<template>
  <div>
    <CRow>
      <CCol xs="12" lg="12">
        <CCard>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>Create Educational Institute</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <CAlert
                :color="messageColor"
                closeButton
                :show.sync="dismissCountDown"
                fade
            >
              {{ err_msg }}
            </CAlert>
            <CForm @submit.prevent="onProfileSubmit">
              <h3>Institute Detail</h3>
              <hr>
              <CRow>
                <CCol md="6">
                  <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.institute.instituteType.$error }"
                  >
                    <label class="form__label">
                      Institute Type
                      <required_span />
                    </label>

                    <div class="d-flex gap-4 align-items-center">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="institute-college"
                          value="College"
                          v-model="institute.instituteType"
                        />
                        <label class="form-check-label" for="institute-college">
                          College
                        </label>
                      </div>

                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="institute-school"
                          value="School"
                          v-model="institute.instituteType"
                        />
                        <label class="form-check-label" for="institute-school">
                          School
                        </label>
                      </div>
                    </div>

                    <small class="error" v-if="$v.institute.instituteType.$error">
                      {{ $lang.institute.validation.required.instituteType }}
                    </small>
                  </div>
                </CCol>
                <CCol md="6">
                  <div class="form-group" :class="{ 'form-group--error': $v.institute.instituteName.$error }">
                    <label class="form__label">{{ $lang.institute.form.instituteName }}
                      <required_span/>
                    </label>
                    <input
                        type="text"
                        :maxlength="maxlength.instituteName"
                        :placeholder="$lang.institute.form.instituteName"
                        class="form-control"
                        v-model="institute.instituteName"
                    />
                    <small
                        class="error"
                        v-if="$v.institute.instituteName.$error && !$v.institute.instituteName.required"
                    >{{ $lang.institute.validation.required.instituteName }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div class="form-group"
                    :class="{ 'form-group--error': $v.institute.type.$error }">
                    <label class="form__label">Type
                      <required_span />
                    </label>
                    <v-select :options="typeOptions" v-model="institute.type" />
                    <small class="error" v-if="$v.institute.type.$error">{{
                      $lang.institute.validation.required.type }}</small>
                  </div>
							  </CCol>
                <CCol md="6">
                  <div class="form-group">
                    <label class="form__label">{{ $lang.institute.form.gst }}</label>
                    <input
                        type="text"
                        :maxlength="maxlength.gst"
                        :placeholder="$lang.institute.form.gst"
                        class="form-control"
                        v-model="institute.gst"
                    />
                    <!-- <small
                        class="error"
                        v-if="$v.institute.gst.$error && !$v.institute.gst.required"
                    >{{ $lang.institute.validation.required.gst }}</small
                    > -->
                  </div>
                </CCol>
                <CCol md="12">
                  <div class="form-group" :class="{ 'form-group--error': $v.institute.summary.$error }">
                    <label class="form__label">{{ $lang.institute.form.summary }}
                      <required_span/>
                    </label>
                    <textarea
                        :maxlength="maxlength.summary"
                        :placeholder="$lang.institute.form.summary"
                        class="form-control"
                        v-model="institute.summary"
                    />
                    <small
                        class="error"
                        v-if="$v.institute.summary.$error && !$v.institute.summary.required"
                    >{{ $lang.institute.validation.required.summary }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div class="form-group" :class="{ 'form-group--error': $v.institute.licence.$error }">
                    <label class="form__label">{{ $lang.institute.form.licence }}
                      <required_span/>
                    </label>
                    <input
                        type="text"
                        :maxlength="maxlength.licence"
                        :placeholder="$lang.institute.form.licence"
                        class="form-control"
                        v-model="institute.licence"
                    />
                    <small
                        class="error"
                        v-if="$v.institute.licence.$error && !$v.institute.licence.required"
                    >{{ $lang.institute.validation.required.licence }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div class="form-group" :class="{ 'form-group--error': $v.institute.website.$error }">
                    <label class="form__label">{{ $lang.institute.form.website }}
                      <required_span/>
                    </label>
                    <input
                        type="text"
                        :maxlength="maxlength.website"
                        :placeholder="$lang.institute.form.website"
                        class="form-control"
                        v-model="institute.website"
                    />
                    <small
                        class="error"
                        v-if="$v.institute.website.$error && !$v.institute.website.required"
                    >{{ $lang.institute.validation.required.website }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div
                      class="form-group"
                      :class="{ 'form-group--error': $v.institute.educationemail.$error }"
                  >
                    <label class="form__label"
                    >{{ $lang.institute.form.educationemail }}
                      <required_span/>
                    </label>
                    <input
                        :maxlength="maxlength.educationemail"
                        type="text"
                        :placeholder="$lang.institute.form.educationemail"
                        class="form-control"
                        v-model="institute.educationemail"
                    />
                    <small
                        class="error"
                        v-if="$v.institute.educationemail.$error && !$v.institute.educationemail.required"
                    >{{ $lang.institute.validation.required.educationemail }}</small
                    >
                    <small
                        class="error"
                        v-if="$v.institute.educationemail.$error && !$v.institute.educationemail.email"
                    >{{ $lang.institute.validation.educationemail.email }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div
                      class="form-group"
                      :class="{
                      'form-group--error': $v.institute.mobileNumber.$error,
                    }"
                  >
                    <label class="form__label"
                    >{{ $lang.institute.form.mobileNumber }}
                      <required_span
                      />
                    </label>
                    <vue-tel-input
                      class="form-group"
                      v-model="institute.mobileNumber"
                      v-on:country-changed="countryChanged"
                      v-bind="bindProps"
                    ></vue-tel-input>
                    <small
                        class="error"
                        v-if="
                        $v.institute.mobileNumber.$error &&
                        !$v.institute.mobileNumber.required
                      "
                    >{{ $lang.institute.validation.required.mobileNumber }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div
                      class="form-group"
                      :class="{ 'form-group--error': $v.institute.address1.$error }"
                  >
                    <label class="form__label"
                    >{{ $lang.institute.form.address1 }}
                      <required_span/>
                    </label>
                    <input
                      type:text
                      :maxlength="maxlength.address1"
                      :placeholder="$lang.institute.form.address1"
                      class="form-control"
                      v-model="institute.address1"
                    />

                    <small
                        class="error"
                        v-if="
                        $v.institute.address1.$error && !$v.institute.address1.required
                      "
                    >{{ $lang.institute.validation.required.address1 }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div class="form-group" :class="{ 'form-group--error': '' }">
                    <label class="form__label"
                    >{{ $lang.institute.form.country }}
                      <required_span/>
                    </label>
                    <v-select
                        :options="countryOptions"
                        v-model="institute.country"
                        @option:selected="loadState"
                    >
                    </v-select>
                    <small
                        class="error"
                        v-if="$v.institute.country.$error && !$v.institute.country.required"
                    >
                      {{ $lang.institute.validation.required.country }}
                    </small>
                  </div>
                </CCol>
                <CCol md="6">
                  <div
                      class="form-group"
                      :class="{ 'form-group--error': $v.institute.state.$error }"
                  >
                    <label class="form__label"
                    >{{ $lang.institute.form.state }}
                      <required_span/>
                    </label>
                    <v-select
                        :options="StateOptions"
                        v-model="institute.state"
                        @option:selected="loadCity"
                    >
                    </v-select>
                    <small
                        class="error"
                        v-if="$v.institute.state.$error && !$v.institute.state.required"
                    >{{ $lang.institute.validation.required.state }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div
                      class="form-group"
                      :class="{ 'form-group--error': $v.institute.city.$error }"
                  >
                    <label class="form__label"
                    >{{ $lang.institute.form.city }}
                      <required_span/>
                    </label>
                    <v-select :options="cityOptions" v-model="institute.city">
                    </v-select>
                    <small
                        class="error"
                        v-if="$v.institute.city.$error && !$v.institute.city.required"
                    >{{ $lang.institute.validation.required.city }}</small
                    >
                  </div>
                </CCol>
              </CRow>
              <hr>
              <h3>Admin User</h3>
              <hr>
              <CRow>
                <CCol md="6">
                  <div class="form-group" :class="{ 'form-group--error': $v.institute.adminName.$error }">
                    <label class="form__label">{{ $lang.institute.form.adminName }}
                      <required_span/>
                    </label>
                    <input
                        type="text"
                        :maxlength="maxlength.adminName"
                        :placeholder="$lang.institute.form.adminName"
                        class="form-control"
                        v-model="institute.adminName"
                    />
                    <small
                        class="error"
                        v-if="$v.institute.adminName.$error && !$v.institute.adminName.required"
                    >{{ $lang.institute.validation.required.adminName }}</small
                    >
                  </div>
                </CCol>
               
                <CCol md="6">
                  <div class="form-group" :class="{ 'form-group--error': $v.institute.reflink.$error }">
                    <label class="form__label">{{ $lang.institute.form.reflink }}
                      <required_span/>
                    </label>
                    <input
                        type="text"
                        :maxlength="maxlength.reflink"
                        :placeholder="$lang.institute.form.reflink"
                        class="form-control"
                        v-model="institute.reflink"
                    />
                    <small
                        class="error"
                        v-if="$v.institute.reflink.$error && !$v.institute.reflink.required"
                    >{{ $lang.institute.validation.required.reflink }}</small
                    >
                  </div>
                </CCol>
                <CCol md="6">
                  <div class="form-group"
                    :class="{ 'form-group--error': $v.institute.designation.$error }">
                    <label class="form__label">Designation
                      <required_span />
                    </label>
                    <v-select :options="designationOptions" v-model="institute.designation" />
                    <small class="error" v-if="$v.institute.designation.$error">{{
                      $lang.institute.validation.required.designation }}</small>
                  </div>
							  </CCol>
                <CCol md="6">
                  <div
                      class="form-group"
                      :class="{ 'form-group--error': $v.institute.adminemail.$error }"
                  >
                    <label class="form__label"
                    >{{ $lang.institute.form.adminemail }}
                      <required_span/>
                    </label>
                    <input
                        :maxlength="maxlength.adminemail"
                        type="text"
                        :placeholder="$lang.institute.form.adminemail"
                        class="form-control"
                        v-model="institute.adminemail"
                    />
                    <small
                        class="error"
                        v-if="$v.institute.adminemail.$error && !$v.institute.adminemail.required"
                    >{{ $lang.institute.validation.required.adminemail }}</small
                    >
                    <small
                        class="error"
                        v-if="$v.institute.adminemail.$error && !$v.institute.adminemail.email"
                    >{{ $lang.institute.validation.adminemail.email }}</small
                    >
                  </div>
                </CCol>
                
              </CRow>
              <CRow>
                <CCol md="12">
                  <div class="form-group" :class="{ 'form-group--error': '' }">
                    <img :src="SRCIMAGE" v-if="SRCIMAGE" alt="Profile Image"/>
                    <ImageCropper @profileImage="getProfile($event)"/>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol col="6" class="text-left">
                  <CButton
                      color="primary"
                      :disabled="submitted"
                      class="px-4"
                      type="submit"
                  >
                    {{ $lang.common.general.submit }}
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {
  staff,
  country,
  state,
  city,
  timezones
} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {
  required,
  email,
} from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import ImageCropper from "../ImageCropper";
import VueTelInput from "vue-tel-input-fix";
import "vue-tel-input-fix/dist/vue-tel-input.css";
import {Maxlength} from "../../store/maxlength";

// Vue.use(VueTelInput);
Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "Profile",
  mixins: [Mixin],
  components: {
    VueTelInput,
    required_span,
    ImageCropper,
  },
  data() {
    return {
      bindProps: {
        mode: "international",
        placeholder: "Contact No.",
        defaultCountry: "IN",
        dropdownOptions: {
          showFlags: true,
        },
        inputOptions: {
          maxlength: Maxlength.institute.mobile,
          showDialCode:true
        },
        validCharactersOnly: true,
      },
      messageColor: "",
      submitted: false,
      SubmitBtn: "Submit",
      FILE: null,
      imgSrc: null,
      SRCIMAGE: null,
      existImage: false,
      imageURL: null,
      imageRemove: null,
      imageOutput: "",
      saving: false,
      saved: false,
      adminId: "",
      err_msg: "",
      largeModal: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      self: this,
      msg: "",
      items: [],
      typeOptions:[
        {
          'value' : 1,
          'label' : "Government",
        },
        {
          'value' : 2,
          'label' : "Grant-in-Aid",
        },
        {
          'value' : 3,
          'label' : "Private",
        }
      ],
      countryOptions: [],
      StateOptions: [],
      cityOptions: [],
      designationOptions:[],
      timezoneOptions: [],
      activePage: 1,
      module: staff,
      moduleCountry: country,
      moduleState: state,
      moduleCity: city,
      moduleTimezone: timezones,
      avatar: {
        imageURl: "",
      },
      institute: {
        instituteType:"",
        instituteName: "",
        imageURL: "",
        address1: "",
        country: "",
        state: "",
        city: "",
        mobileNumber: "",
        mobileNumberCode: "",
        type:"",
        gst:"",
        summary:"",
        educationemail:"",
        licence:"",
        designation:"",
        website:"",
        adminemail:"",
        reflink:"",
        adminName:""
      },
      maxlength: {
        instituteName: Maxlength.institute.instituteName,
        email: Maxlength.institute.email,
        address1: Maxlength.institute.address1,
      },
    };
  },
  validations: {
    institute: {
      instituteName: {
        required,
      },
      summary:{
        required,
      },
      instituteType: {
        required,
      },
      country: {
        required,
      },
      state: {
        required,
      },
      city: {
        required,
      },
      address1: {
        required,
      },
      mobileNumber: {
        required,
      },
      type: {
        required,
      },
      gst: {
        // required,
        // gstFormat: helpers.withMessage(
        //   'Invalid GST number format',
        //   helpers.regex(
        //     'gstFormat',
        //     /^([0-9]{2})([A-Z]{5})([0-9]{4})([A-Z]{1})([1-9A-Z]{1})(Z)([0-9A-Z]{1})$/
        //   )
        // )
      },
      licence: {
        required,
      },
      website: {
        required,
      },
      reflink: {
        required,
      },
      designation: {
        required,
      },
      adminName: {
        required,
      },
      educationemail: {
        required,
        email,
      },
      adminemail: {
        required,
        email,
      },
    },
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    self.dismissCountDown = 0;
    this.$root.$on("alert", (arg1, arg2) => {
    });
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
    axios.post('groups/category-title/admin/list',{type:"College"})
      .then((response) => {
        response.data.map(function (value, key) {
          self.designationOptions.push({ value: value.id, label: value.title });
        });
      });

      axios.get(this.listUrlApi(this.moduleCountry))
      .then((response) => {
        response.data.data.map(function (value, key) {
          self.countryOptions.push({ value: value.id, label: value.name });
        });
      });
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
    avatar: {
      handler: function () {
        this.saved = false;
      },
      deep: true,
    },
  },
  methods: {
    countryChanged(country) {
      let self = this;
      self.institute.mobileNumberCode = "+" + country.dialCode;
      let mobile = self.institute.mobileNumber;
      self.institute.mobileNumber = mobile
          .replace("+" + country.dialCode, "")
          .trim();
    },

    loadState() {
      let self = this;
      const postData = {countryId: self.institute.country.value};
      self.institute.state = {}; //reset
      axios
          .post(this.listUrlApi(this.moduleState), postData)
          .then((response) => {
            self.StateOptions = [];
            response.data.data.map(function (value, key) {
              self.StateOptions.push({value: value.id, label: value.name});
            });
          });
    },
    loadCity() {
      let self = this;
      const postData = {stateId: self.institute.state.value};
      self.institute.city = {}; //reset
      axios
          .post(this.listUrlApi(this.moduleCity), postData)
          .then((response) => {
            self.cityOptions = [];
            response.data.data.map(function (value, key) {
              self.cityOptions.push({value: value.id, label: value.name});
            });
          });
    },
    getProfile(profile) {
      let self = this;
      self.institute.imageURL = profile;
      if (profile === "") {
        self.institute.imageRemove = 1;
      } else {
        self.institute.imageRemove = 0;
      }
    },
    onFileUpload(event) {
      this.FILE = event.target.files[0];
    },
    onProfileSubmit() {
      let self = this;
      this.$v.institute.$touch();
      if (this.$v.institute.$invalid) {
        self.submitted = false; //Enable Button
        this.submitStatus = "ERROR";
      } else {
        let self = this;
        self.submitted = true; //Disable Button
        const formData = new FormData();
        formData.append("image", self.institute.imageURL);
        formData.append("college", self.institute.instituteName);
        formData.append("description", self.institute.summary);
        formData.append("licenceNumber", self.institute.licence);
        formData.append("address1", self.institute.address1);
        formData.append("gstNumber", self.institute.gst);
        // formData.append("timezone", self.institute.timezone.value);
        formData.append("university", self.institute.state.value);
        formData.append("collegeTypeId", self.institute.type.value);
        formData.append("collegeType", self.institute.type.label);
        formData.append("educationInstituteType", self.institute.instituteType);
        formData.append("professionalLink", self.institute.reflink);
        formData.append("country", self.institute.country.value);
        formData.append("state", self.institute.state.value);
        formData.append("city", self.institute.city.value);
        formData.append("website", self.institute.website);
        formData.append("name", self.institute.adminName);
        formData.append("titleId", self.institute.designation.value);
        formData.append("email", self.institute.adminemail);
        formData.append("collegeEmail", self.institute.educationemail);
        formData.append("username", self.institute.mobileNumber);
        formData.append("countryCode", self.institute.mobileNumberCode);
        axios
            .post('users/profiles/institute/create', formData)
            .then((response) => {
              self.submitted = false; //Enable Button
              store.commit("showLoader", false); // Loader Off
              if (response.data.code === 200) {
                self.err_msg = response.data.message;
                localStorage.setItem("notificationType", "success");
                localStorage.setItem(
                    "notificationMessage",
                    response.data.message
                );
                this.$router.push({name: "Educational Institutes"});
                self.dismissCountDown = 10;
                self.messageColor = "success";
              } else {
                self.err_msg = response.data.message;
                self.messageColor = "danger";
                self.dismissCountDown = 10;
              }
            }).catch(function (error) {
          let data;
          if (error.response.data.error) {
            data = error.response.data.error.toString();
          } else {
            data = error.response.data.message;
          }
          self.err_msg = data;
          self.messageColor = "danger";
          self.dismissCountDown = 10;
          self.submitted = false; //Enable Button
        });
      }
    },
    setAlert(value) {
      this.showAlert = value;
    },
    createTableRow() {
      this.$router.push({name: "Profile Create"});
    },
    rowClicked(item, index) {
      this.$router.push({path: `country/view/${item}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    loadData() {
      let self = this;
      axios
          .get(this.listUrlApi(this.module), self.model)
          .then(function (response) {
            if (response) {
              self.data = response.data;
            } else {
              self.data = [];
            }
          });
    },
  },
};
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
